"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExistenceStatusStatusEnum = exports.ExistenceStatusToJSON = exports.ExistenceStatusFromJSONTyped = exports.ExistenceStatusFromJSON = void 0;
function ExistenceStatusFromJSON(json) {
    return ExistenceStatusFromJSONTyped(json, false);
}
exports.ExistenceStatusFromJSON = ExistenceStatusFromJSON;
function ExistenceStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': json['status'],
        'expirationDate': (new Date(json['expirationDate'])),
    };
}
exports.ExistenceStatusFromJSONTyped = ExistenceStatusFromJSONTyped;
function ExistenceStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'expirationDate': (value.expirationDate.toISOString().substr(0, 10)),
    };
}
exports.ExistenceStatusToJSON = ExistenceStatusToJSON;
/**
* @export
* @enum {string}
*/
var ExistenceStatusStatusEnum;
(function (ExistenceStatusStatusEnum) {
    ExistenceStatusStatusEnum["FOUND"] = "FOUND";
    ExistenceStatusStatusEnum["PENDING"] = "PENDING";
    ExistenceStatusStatusEnum["REFINESEARCHUSEKTN"] = "REFINE_SEARCH_USE_KTN";
    ExistenceStatusStatusEnum["NOTFOUND"] = "NOT_FOUND";
    ExistenceStatusStatusEnum["ERROR"] = "ERROR";
    ExistenceStatusStatusEnum["INVALIDVALUE"] = "_INVALID_VALUE";
    ExistenceStatusStatusEnum["FOUNDINCLEAR"] = "FOUND_IN_CLEAR";
})(ExistenceStatusStatusEnum = exports.ExistenceStatusStatusEnum || (exports.ExistenceStatusStatusEnum = {}));
//# sourceMappingURL=ExistenceStatus.js.map